var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WidgetWrapper',{staticClass:"bg-transparent d-flex flex-column",attrs:{"title":_vm.$$t('Participants')}},[_c('PerformanceIndicators',_vm._b({},'PerformanceIndicators',{
      indicators: _vm.indicators,
    },false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }